export default __webpack_public_path__ + "static/media/logo-insta.d1cf233f.png";